// IMPORTANT NOTE: When adding an icon, please maintain keys ordered by name
/**
 * @description Available icon names
 */
let IconNames = /*#__PURE__*/function (IconNames) {
  IconNames["ADD_FILLED"] = "ADD_FILLED";
  IconNames["ADD"] = "ADD";
  IconNames["AGENT"] = "AGENT";
  IconNames["ALERT"] = "ALERT";
  IconNames["ANALYTICS"] = "ANALYTICS";
  IconNames["CONVERSATION"] = "CONVERSATION";
  IconNames["ARROW_BOTTOM"] = "ARROW_BOTTOM";
  IconNames["ARROW_LEFT"] = "ARROW_LEFT";
  IconNames["ARROW_RIGHT"] = "ARROW_RIGHT";
  IconNames["ARROW_TOP"] = "ARROW_TOP";
  IconNames["ATTACH"] = "ATTACH";
  IconNames["AUTOMATION"] = "AUTOMATION";
  IconNames["BELL"] = "BELL";
  IconNames["BOAT"] = "BOAT";
  IconNames["BUCKET"] = "BUCKET";
  IconNames["BUFFER"] = "BUFFER";
  IconNames["CALENDAR"] = "CALENDAR";
  IconNames["CANCEL_FILLED"] = "CANCEL_FILLED";
  IconNames["CANCEL"] = "CANCEL";
  IconNames["CAR"] = "CAR";
  IconNames["CARDBOARD_BOX_CHECK"] = "CARDBOARD_BOX_CHECK";
  IconNames["CARDBOARD_BOX_SHIELD"] = "CARDBOARD_BOX_SHIELD";
  IconNames["CARDBOARD_BOX"] = "CARDBOARD_BOX";
  IconNames["CARET_BOTTOM"] = "CARET_BOTTOM";
  IconNames["CARET_TOP"] = "CARET_TOP";
  IconNames["CARGO"] = "CARGO";
  IconNames["CART"] = "CART";
  IconNames["CASH_DISABLED"] = "CASH_DISABLED";
  IconNames["CASH"] = "CASH";
  IconNames["CHART_UPWARDS"] = "CHART_UPWARDS";
  IconNames["CHECK_FILLED"] = "CHECK_FILLED";
  IconNames["CHECK_MARK"] = "CHECK_MARK";
  IconNames["CHECK"] = "CHECK";
  IconNames["CHEVRON_BOTTOM"] = "CHEVRON_BOTTOM";
  IconNames["CHEVRON_LEFT"] = "CHEVRON_LEFT";
  IconNames["CHEVRON_RIGHT"] = "CHEVRON_RIGHT";
  IconNames["CHEVRON_TOP"] = "CHEVRON_TOP";
  IconNames["CIRCLE"] = "CIRCLE";
  IconNames["CIRCULAR_ARROW"] = "CIRCULAR_ARROW";
  IconNames["CLOCK"] = "CLOCK";
  IconNames["CLOSE"] = "CLOSE";
  IconNames["CODE"] = "CODE";
  IconNames["COINS"] = "COINS";
  IconNames["CONTRACT"] = "CONTRACT";
  IconNames["COPY"] = "COPY";
  IconNames["CREDIT_CARD"] = "CREDIT_CARD";
  IconNames["DASH"] = "DASH";
  IconNames["DESKTOP"] = "DESKTOP";
  IconNames["DOOR_DELIVERY"] = "DOOR_DELIVERY";
  IconNames["DOTS"] = "DOTS";
  IconNames["DOWNLOAD"] = "DOWNLOAD";
  IconNames["DRAG_DROP"] = "DRAG_DROP";
  IconNames["DRAG_INDICATOR"] = "DRAG_INDICATOR";
  IconNames["DUPLICATE"] = "DUPLICATE";
  IconNames["ECOMMERCE"] = "ECOMMERCE";
  IconNames["EDIT"] = "EDIT";
  IconNames["EYE_DISABLED"] = "EYE_DISABLED";
  IconNames["EYE"] = "EYE";
  IconNames["FAST_DELIVERY"] = "FAST_DELIVERY";
  IconNames["FEATURED"] = "FEATURED";
  IconNames["FEATURED_FILLED"] = "FEATURED_FILLED";
  IconNames["FILE_LIST"] = "FILE_LIST";
  IconNames["FILE_PDF"] = "FILE_PDF";
  IconNames["FILE"] = "FILE";
  IconNames["FILTER"] = "FILTER";
  IconNames["FORKLIFT"] = "FORKLIFT";
  IconNames["FOUR"] = "FOUR";
  IconNames["FRAGILE"] = "FRAGILE";
  IconNames["GIFT"] = "GIFT";
  IconNames["GROUP"] = "GROUP";
  IconNames["HAND_BOX"] = "HAND_BOX";
  IconNames["HARD_BOX"] = "HARD_BOX";
  IconNames["HELP"] = "HELP";
  IconNames["HOURGLASS"] = "HOURGLASS";
  IconNames["HOUSE"] = "HOUSE";
  IconNames["IMPORT"] = "IMPORT";
  IconNames["INBOX"] = "INBOX";
  IconNames["INFO_FILLED"] = "INFO_FILLED";
  IconNames["INFO"] = "INFO";
  IconNames["KEY"] = "KEY";
  IconNames["LABEL"] = "LABEL";
  IconNames["LIST"] = "LIST";
  IconNames["LOGOUT_BOLD"] = "LOGOUT_BOLD";
  IconNames["LOGOUT"] = "LOGOUT";
  IconNames["MAIL"] = "MAIL";
  IconNames["MAP"] = "MAP";
  IconNames["MARGIN_PROFILE"] = "MARGIN_PROFILE";
  IconNames["MARKER_FILLED"] = "MARKER_FILLED";
  IconNames["MARKER"] = "MARKER";
  IconNames["MENU"] = "MENU";
  IconNames["MOBILE"] = "MOBILE";
  IconNames["MONEY"] = "MONEY";
  IconNames["NEW_WINDOW"] = "NEW_WINDOW";
  IconNames["ONE"] = "ONE";
  IconNames["OPEN_BOX"] = "OPEN_BOX";
  IconNames["PADLOCK_OPEN"] = "PADLOCK_OPEN";
  IconNames["PADLOCK"] = "PADLOCK";
  IconNames["PAGINATION_LEFT"] = "PAGINATION_LEFT";
  IconNames["PAGINATION_RIGHT"] = "PAGINATION_RIGHT";
  IconNames["PALLET"] = "PALLET";
  IconNames["PANTONE"] = "PANTONE";
  IconNames["PERCENTAGE"] = "PERCENTAGE";
  IconNames["PLANE"] = "PLANE";
  IconNames["PLUG"] = "PLUG";
  IconNames["PLUS"] = "PLUS";
  IconNames["PRINTER_DISABLED"] = "PRINTER_DISABLED";
  IconNames["PRINTER"] = "PRINTER";
  IconNames["REMOVE_FILLED"] = "REMOVE_FILLED";
  IconNames["REMOVE"] = "REMOVE";
  IconNames["ROCKET"] = "ROCKET";
  IconNames["SAVINGS"] = "SAVINGS";
  IconNames["SCAN_BARCODE"] = "SCAN_BARCODE";
  IconNames["SCAN_QR"] = "SCAN_QR";
  IconNames["SEARCH"] = "SEARCH";
  IconNames["SETTINGS"] = "SETTINGS";
  IconNames["SHIELD_DISABLED"] = "SHIELD_DISABLED";
  IconNames["SHIELD"] = "SHIELD";
  IconNames["SINGLE_COLLECTION"] = "SINGLE_COLLECTION";
  IconNames["SORT_ALPHA_ASC"] = "SORT_ALPHA_ASC";
  IconNames["SORT_ALPHA_DESC"] = "SORT_ALPHA_DESC";
  IconNames["SORT"] = "SORT";
  IconNames["SPEED_TRUCK"] = "SPEED_TRUCK";
  IconNames["SPINNER"] = "SPINNER";
  IconNames["STORE"] = "STORE";
  IconNames["SUBSCRIPTION"] = "SUBSCRIPTION";
  IconNames["TABLET"] = "TABLET";
  IconNames["THREE"] = "THREE";
  IconNames["TIMER"] = "TIMER";
  IconNames["TRACKING"] = "TRACKING";
  IconNames["TRAIN"] = "TRAIN";
  IconNames["TRASH"] = "TRASH";
  IconNames["TROLLEY"] = "TROLLEY";
  IconNames["TRUCK"] = "TRUCK";
  IconNames["TWO"] = "TWO";
  IconNames["USER_FILLED"] = "USER_FILLED";
  IconNames["USER"] = "USER";
  IconNames["UPGRADE"] = "UPGRADE";
  IconNames["VAN"] = "VAN";
  IconNames["WAREHOUSE"] = "WAREHOUSE";
  IconNames["WEIGHT"] = "WEIGHT";
  IconNames["WEIGHT_GRAMS"] = "WEIGHT_GRAMS";
  IconNames["WEIGHT_OUNCE"] = "WEIGHT_OUNCE";
  IconNames["WEIGHT_POUND"] = "WEIGHT_POUND";
  IconNames["WORLD_SHIPPING"] = "WORLD_SHIPPING";
  IconNames["WORLD"] = "WORLD";
  return IconNames;
}({});

export { IconNames };
//# sourceMappingURL=Icons.js.map
